<template>
  <transition v-on:enter="enter" v-on:leave="leave">
    <div
      v-if="user"
      class="user-popup-frame target-frame"
      @click="$emit('active', false)"
      v-show="active"
    >
      <div class="user-popup-box" :class="{ 'user-popup-active': active }">
        <div class="user-popup-info">
          <div class="user-popup-photo user-photo">
            <img
              :src="
                user.image_url
                  ? $mediaUrl(user.image_url)
                  : require('../assets/images/user.png')
              "
              alt=""
            />
            <label for="editImg"
              ><img src="../assets/images/camera-solid.svg" alt=""
            /></label>
            <input
              @change="userUpdate($event)"
              type="file"
              accept=".png, .jpg, .jpeg"
              id="editImg"
            />
          </div>
          <div class="user-popup-name">
            <h3>{{ user.first_name }}</h3>
          </div>
        </div>
        <ul class="user-menu">
          <li :class="{ 'user-active-page': $route.path === '/user' }">
            <router-link to="/user"
              ><i class="fa-book"></i>
              <div>{{ $t("my_courses") }}</div></router-link
            >
          </li>
          <li :class="{ 'user-active-page': $route.path === '/desires' }">
            <router-link to="/desires"
              ><i class="fa-save-fill"></i>
              <div>{{ $t("interests") }}</div></router-link
            >
          </li>
          <li :class="{ 'user-active-page': $route.path === '/certificates' }">
            <router-link to="/certificates"
              ><i class="fa-certificate"></i>
              <div>{{ $t("certificates") }}</div></router-link
            >
          </li>
          <!--<li :class="{'user-active-page' : $route.path === '/bonus'}">
            <router-link to="/bonus"><i class="fa-bonus"></i><div v-cyr2lat="lang">Bonuslar</div></router-link>
          </li>-->
          <li :class="{ 'user-active-page': $route.path === '/profile' }">
            <router-link to="/profile">
              <i class="fa-user"></i>
              <div>{{ $t("profile") }}</div>
              <svg
                class="invalid"
                v-if="
                  user.first_name === '' ||
                  user.last_name === '' ||
                  user.full_name === '' ||
                  user.date_birth === '' ||
                  user.login === '' ||
                  user.city === ''
                "
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192 512"
              >
                <path
                  fill="currentColor"
                  d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                ></path>
              </svg>
            </router-link>
          </li>
          <li class="user-link-out js-popup-out">
            <a @click.stop="logoutPopup = true" href="#"
              ><i class="fa-out"></i>
              <div>{{ $t("exit") }}</div></a
            >
          </li>
        </ul>
      </div>
      <DeleteCoursePopup
        @close="logoutPopupFunc"
        :logout-event="true"
        @logout="logout"
        v-if="logoutPopup"
      />
    </div>
  </transition>
</template>

<script>
import Velocity from "velocity-animate";
import DeleteCoursePopup from "../components/DeleteCoursePopup";

export default {
  data() {
    return {
      logoutPopup: false,
    };
  },
  components: {
    DeleteCoursePopup,
  },
  props: {
    active: {
      type: Boolean,

      default: false,
    },
  },
  mounted() {},
  methods: {
    setClass: function (active) {
      if (active === true) {
        return "open";
      }
      return "close";
    },

    enter: function (el, done) {
      Velocity(
        el,
        "fadeIn",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },

    leave: function (el, done) {
      Velocity(
        el,
        "fadeOut",
        {
          duration: 200,
          easing: "easeInBack",
        },
        { complete: done },
      );
    },
    logoutPopupFunc(e) {
      this.logoutPopup = e;
    },
    async logout(e) {
      if (e) {
        await this.$store.dispatch("logout");
        await this.$router.push("/login");
      }
    },
  },
  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    notification() {
      return this.$store.getters.getNotifications;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
};
</script>
